import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { RestaurantWithEventSpaces } from "@/types/restaurant";
import type { FilterParams } from "@/types/filters";
import { filterRestaurants } from "@/utils/restaurantFilterUtils";
import { queryKeys, RESTAURANT_SELECT, SSR_STALE_TIME } from "@/lib/queryKeys";

export const useRestaurantFilters = (filters: FilterParams) => {
  return useQuery({
    queryKey: queryKeys.restaurants(filters),
    staleTime: SSR_STALE_TIME,
    queryFn: async () => {
      console.log('useRestaurantFilters - Starting filter operation with:', filters);
      
      const { data, error } = await supabase
        .from('restaurants')
        .select(RESTAURANT_SELECT)
        .eq('approval_status', 'approved');

      if (error) {
        console.error('useRestaurantFilters - Error fetching restaurants:', error);
        throw error;
      }

      const restaurants = data as RestaurantWithEventSpaces[];
      return filterRestaurants(restaurants, filters);
    },
  });
};
